import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import Option from './option';
import SingleValue from './single-value';
import Input from './input';

const components = {
  Option,
  SingleValue,
  Input,
};

const { SimpleSelect } = designSystem;

const ColorSchemeSelect = forwardRef(
  (
    {
      defaultValue = null,
      onChange,
      options,
      preventOverflow = false,
      openMenuOnFocus = false,
      size = 'small',
    },
    ref
  ) => (
    <SimpleSelect
      ref={ref}
      clearable={false}
      components={components}
      defaultValue={defaultValue}
      onChange={onChange}
      options={options}
      preventOverflow={preventOverflow}
      openMenuOnFocus={openMenuOnFocus}
      size={size}
    />
  )
);

ColorSchemeSelect.displayName = 'ColorSchemeSelect';

ColorSchemeSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      iconComponent: PropTypes.node.isRequired,
    })
  ).isRequired,
  defaultValue: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconComponent: PropTypes.node.isRequired,
  }),
  size: PropTypes.array,
  preventOverflow: PropTypes.bool,
  openMenuOnFocus: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

export default ColorSchemeSelect;
